var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 22C15.0147 22 13 19.9853 13 17.5C13 15.0147 15.0147 13 17.5 13C19.9853 13 22 15.0147 22 17.5C22 19.9853 19.9853 22 17.5 22ZM20.0303 16.0303C20.3232 15.7374 20.3232 15.2626 20.0303 14.9697C19.7374 14.6768 19.2626 14.6768 18.9697 14.9697L17.5 16.4393L16.0303 14.9697C15.7374 14.6768 15.2626 14.6768 14.9697 14.9697C14.6768 15.2626 14.6768 15.7374 14.9697 16.0303L16.4393 17.5L14.9697 18.9697C14.6768 19.2626 14.6768 19.7374 14.9697 20.0303C15.2626 20.3232 15.7374 20.3232 16.0303 20.0303L17.5 18.5607L18.9697 20.0303C19.2626 20.3232 19.7374 20.3232 20.0303 20.0303C20.3232 19.7374 20.3232 19.2626 20.0303 18.9697L18.5607 17.5L20.0303 16.0303Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C12.2091 10 14 8.20914 14 6C14 3.79086 12.2091 2 10 2C7.79086 2 6 3.79086 6 6C6 8.20914 7.79086 10 10 10Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12C2.89543 12 2 12.8954 2 14C2 18.4183 5.58172 22 10 22C11.0485 22 12.0499 21.7983 12.9675 21.4316C12.0533 20.3786 11.5 19.0039 11.5 17.5C11.5 15.0403 12.9801 12.9263 15.0983 12H4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRemove);
export default __webpack_public_path__ + "static/media/user-remove.d31b22a30b6a81f0a82e17358d5162cc.svg";
export { ForwardRef as ReactComponent };